import React from 'react'

import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import type { TooltipProps } from 'recharts'

interface PointsBreakdown {
    daily: { amount: number }
    volume: { amount: number }
    // socialPoints: { amount: number }
    // feedbackPoints: { amount: number }
    // referralPoints: { amount: number }
    // miscPoints: { amount: number }
    adjustments: { amount: number }
}

interface Props {
    breakdown: PointsBreakdown | undefined
}

interface ChartData {
    name: string
    value: number
    color: string
    description: string
}

const COLORS = {
    daily: '#4CAF50',
    transaction: '#2196F3',
    social: '#9C27B0',
    feedback: '#00BCD4',
    referral: '#FF9800',
    misc: '#9E9E9E',
}

const PointsBreakdownChart: React.FC<Props> = ({ breakdown }) => {
    if (!breakdown) return null

    const data: ChartData[] = [
        {
            name: 'Daily Swapping',
            value: breakdown.daily?.amount || 0,
            color: COLORS.daily,
            description: 'Earned from daily trading activity',
        },
        {
            name: 'Volume',
            value: breakdown.volume?.amount || 0,
            color: COLORS.transaction,
            description: '1 Mile per dollar swapped',
        },
        // {
        // 	name: 'Social Miles',
        // 	value: breakdown.socialPoints?.amount || 0,
        // 	color: COLORS.social,
        // 	description: 'Earned from Twitter engagement',
        // },
        {
            name: 'Misc Points',
            value: breakdown.adjustments?.amount || 0,
            color: COLORS.misc,
            description: 'Earned from miscellaneous activities',
        },
        // {
        // 	name: 'Referral Points',
        // 	value: breakdown.referralPoints?.amount || 0,
        // 	color: COLORS.referral,
        // 	description: 'Earned from referrals',
        // },
        // {
        // 	name: 'Misc Points',
        // 	value: breakdown.miscPoints?.amount || 0,
        // 	color: COLORS.misc,
        // 	description: 'Earned from miscellaneous activities',
        // },
    ].filter(item => item.value > 0)

    return (
        <div className='space-y-4'>
            <div className='h-[300px] w-full'>
                <ResponsiveContainer width='100%' height='100%'>
                    <PieChart>
                        <Pie
                            data={data}
                            cx='50%'
                            cy='50%'
                            innerRadius={90}
                            outerRadius={120}
                            paddingAngle={5}
                            dataKey='value'
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Pie>
                        <Tooltip
                            content={({ payload }: TooltipProps<number, string>) => {
                                if (!payload?.length) return null
                                const data = payload[0].payload as ChartData
                                return (
                                    <div className='rounded-lg bg-black/90 p-2'>
                                        <div className='flex items-center gap-2'>
                                            <span className='font-medium text-white'>{data.name}</span>
                                        </div>
                                        <p className='text-sm' style={{ color: data.color }}>
                                            {data.value.toLocaleString()} Miles
                                        </p>
                                        <p className='text-sm text-white/60'>{data.description}</p>
                                    </div>
                                )
                            }}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>

            <div className='grid grid-cols-2 gap-3 px-2'>
                {data.map(item => (
                    <div key={item.name} className='flex items-center gap-2'>
                        <div className='h-3 w-3 rounded-full' style={{ backgroundColor: item.color }} />
                        <div className='flex items-center gap-1 text-sm text-white/80'>
                            <span>{item.name}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default PointsBreakdownChart
